<div [ngClass]="{ plane: seatsReceived }">
  @if (seatKeys && !requestActive) {
    @for (key of seatKeys | keyValue: true; track key) {
      <div class="seats-row" [ngClass]="'type-' + key.value?.length">
        @for (
          seat of key.value;
          track seat;
          let index = $index;
          let first = $first;
          let last = $last
        ) {
          <div [ngClass]="seat | seatMapSpacing: first || last : aisleSeatLocation">
            <ng-container
              [ngTemplateOutlet]="buttonTemplate"
              [ngTemplateOutletContext]="{ notAvailable: isNotAvailable(seat) }"
            ></ng-container>
            <ng-template #buttonTemplate let-notAvailable="notAvailable">
              <section class="container" (mouseleave)="tt1.close()">
                <button
                  class="seat available"
                  [ngClass]="{
                    selected: isSelected(seat),
                    'not-available':
                      (!isSelected(seat) && (!seat.available || (seat.price && freeSeatsOnly))) ||
                      shouldLeaveSeatVacant(seat),
                    available: seat.available,
                    'no-seat': seat.price === null
                  }"
                  (click)="selectedSeat(seat)"
                  [ngbTooltip]="tipContent"
                  [disabled]="notAvailable"
                  id="seat-{{ seat.row }}-{{ seat.column }}-{{
                    notAvailable ? 'disabled' : 'available'
                  }}"
                  triggers="manual"
                  #tt1="ngbTooltip"
                  (mouseenter)="tt1.open()"
                  (focus)="tt1.open()"
                  (blur)="tt1.close()"
                >
                  @if (!seat.isFake) {
                    {{ seat.row }}{{ seat.column }}
                  }
                </button>
              </section>
            </ng-template>
            <ng-template #tipContent>
              @if (
                (!isSelected(seat) && (!seat.available || (seat.price && freeSeatsOnly))) ||
                shouldLeaveSeatVacant(seat)
              ) {
                @if (seat.price) {
                  <strong class="blocked" i18n="@@seatmap-policy-blocked">POLICY BLOCKED</strong>
                }
                @if (!seat.price) {
                  <strong class="blocked" i18n="@@seatmap-not-available">NOT AVAILABLE</strong>
                }
              } @else {
                <ng-container>
                  @for (attribute of seat.attributes; track attribute; let last = $last) {
                    <div>
                      {{ attribute.description }}
                      @if (!last) {
                        <span>,</span>
                      }
                    </div>
                  }
                  @if (seat.price) {
                    <span>{{ seat.price }}{{ seat.currency }}</span>
                  }
                  @if (!seat.price) {
                    <span i18n="@@NoAdditionalCharge">No Additional Charge</span>
                  }
                </ng-container>
              }
            </ng-template>
          </div>
        }
      </div>
    }
    @if (!seatsReceived) {
      <div>
        <div class="no_results_message">
          <h4 class="no_results_message_heading">
            <i class="ico-info no_results_icon" i18n="@@seatMapOhNo"></i>Oh, no!
          </h4>
          <p>
            <span i18n="@@seatMapUnavailableMessage"
              >Seat map is unavailable for this flight.
            </span>
          </p>
        </div>
      </div>
    }
    @if (seatsReceived) {
      <div class="button-wrapper">
        <button
          type="button"
          appButton="small"
          (click)="clearSelectedSeat()"
          i18n="@@clear-selection"
          id="clear-selection-button"
          [disabled]="!localSelectedSeat"
        >
          Clear Selection
        </button>
      </div>
    }
  } @else {
    <div class="loadingBlock">
      <app-loading-spinner size="sm" />
    </div>
  }
</div>
